import { Component, OnDestroy, OnInit } from '@angular/core';
import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { LOCAL_STORAGE_KEY } from '@core/configs';
import { AuthService } from '@core/services/apis';
import { LocalStorageService, MstMessageService, MultipleSpinnerService } from '@core/services/common';
import { environment } from '@environments/environment';
import { DbsConfirmDialogV2Component } from '../dbs-confirm-dialog-v2';

@Component({
  selector: 'dbs-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {
  trigger: CdkOverlayOrigin;
  isOpenOtherMenu = false;
  isLoggedIn = false;
  fullName = '';
  timeoutMenu: any;
  subscriptions: Subscription[] = [];

  constructor(
    private multipleSpinnerService: MultipleSpinnerService,
    private localStorageService: LocalStorageService,
    private authService: AuthService,
    private mstMessageService: MstMessageService,
    public dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    const getIsLoggedIn = this.authService.getIsLoggedIn().subscribe((res) => {
      this.isLoggedIn = res;
      this.fullName = localStorage.getItem(LOCAL_STORAGE_KEY.fullName);
    });
    this.subscriptions.push(getIsLoggedIn);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  toggleSidebar(): boolean {
    return false;
  }

  onLogout(): void {
    this.dialog
      .open(DbsConfirmDialogV2Component, {
        panelClass: ['custom-dbs-confirm-dialog-v2'],
        data: {
          message: this.mstMessageService.getMessage(1),
          type: 1,
        },
        disableClose: true,
        autoFocus: false,
      })
      .afterClosed()
      .subscribe(res => {
        if (res) {
          this.authService.logout();
        }
      });
  }

  onLeave() {
    this.timeoutMenu = setTimeout(() => {
      this.isOpenOtherMenu = false;
    }, 300);
  }

  onHover() {
    clearTimeout(this.timeoutMenu);
    this.isOpenOtherMenu = true;
  }

  backdropClick() {
    this.isOpenOtherMenu = false;
  }

  goAccountInformation() {
    this.multipleSpinnerService.show();
    this.authService.verifyRefreshToken().subscribe(async (res) => {
        if (res?.result?.result) {
            window.open(environment.cKPassWebappUrl + 'account-information?accessToken='
                + this.localStorageService.getAccessToken() + '&refreshToken='
                + this.localStorageService.getRefreshToken());
        } else {
            await this.authService.logout();
        }
        this.multipleSpinnerService.hide();
    }, async () => {
        await this.authService.logout();
    });
  }

  navigateHome() {
    return false;
  }
}
